export default __webpack_public_path__ + "static/media/proj2_1.7dc4e1f2.jpg";